import { useTranslation } from 'react-i18next';
import { getTradingSystemName } from '@monorepo/client-types';
import { TradingSystem } from '@monorepo/types';

export interface CTraderLoginContentProps {
  tradingSystem: TradingSystem;
}

export const CTraderLoginContent = ({
  tradingSystem,
}: CTraderLoginContentProps) => {
  const { t } = useTranslation(['login']);
  const platformName = getTradingSystemName(tradingSystem);

  return (
    <div>
      {t('login:traders_login.platform_login_tip', { platform: platformName })}
    </div>
  );
};
